<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->


<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div class="d-flex flex-column gap-8">
  <div id="header-container">
    <div>
      <h1 id="header-text">Global Industry Consolidation Report</h1>
    </div>
    <div>
      <button mat-flat-button color="primary" id="report-button" class="action-button"
              (click)="onRunReport()"
              [disabled]="!memberScenarios || memberScenarios.length === 0">
        Run Report
      </button>
    </div>
  </div>
  <div class="d-flex flex-column justify-content-center default-margin">
    <mat-button-toggle-group [(ngModel)]="selectedSourceType" (ngModelChange)="onSourceChange()"
                             hideSingleSelectionIndicator="true"
                             class="flex max-width">
      <mat-button-toggle id="forecast-org-toggle" [value]="'fcorg'" class="equal-flex-item">
        By Forecast Org
      </mat-button-toggle>
      <mat-button-toggle id="global-scenario-toggle" [value]="'global'" class="equal-flex-item">
        By Global Scenario
      </mat-button-toggle>
      <mat-button-toggle id="tvp-toggle" [value]="'tvp'" class="equal-flex-item">
        By TVP Scenarios
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div class="flex-content">
    <div *ngIf="selectedSourceType">
      <mat-form-field class="default-margin">
        <mat-label class="asterisk--before">Start Year</mat-label>
        <mat-select [(ngModel)]="startYear" id="startYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="default-margin">
        <mat-label class="asterisk--before">End Year</mat-label>
        <mat-select [(ngModel)]="endYear" id="endYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-checkbox [disabled]="disableAggregateTos" [(ngModel)]="aggregateTos">Aggregate Type of Sale</mat-checkbox>
      <mat-checkbox [(ngModel)]="showHiddenScenarios" (ngModelChange)="setAvailableScenariosTables()" id="show-hidden">
        Include Hidden Scenarios
      </mat-checkbox>
    </div>
  </div>
  <div *ngIf="selectedSourceType === 'global'" class="content-height">
    <app-global-scenario-select-component
      [user]="stateService.getUserGmid()"
      [filterNonGM]="true"
      [memberScenarioType]="1"
      (confirmEvent)="onSelectGlobal($event)">
    </app-global-scenario-select-component>
  </div>

  <div *ngIf="selectedSourceType !== 'global'" class="flex-content content-height">
    <div class="w-50">
      <div class="table-title">
        <span>Available Scenarios</span>
      </div>
      <ag-grid-angular
        style="height: 100%; width:100%;"
        class="ag-theme-quartz"
        [rowData]="displayedAvailableScenarios"
        [columnDefs]="INDUSTRY_COLDEF"
        [autoSizeStrategy]="autoSizeStrategy"
        [rowSelection]="rowSelection"
        [postSortRows]="postSortRows"
        (rowSelected)="onSelect($event)"
      />
    </div>
    <div class="actions-container">
      <button mat-icon-button
              matTooltip="Move selected scenario to selected member scenarios"
              [disabled]="selectedIndustryScenarios.length === 0"
              (click)="onAddMemberScenario()"
              id="add-scenario">
        <mat-icon>keyboard_double_arrow_right</mat-icon>
      </button>
      <button mat-icon-button
              matTooltip="Remove selected scenario from selected member scenarios"
              [disabled]="memberScenariosToRemove.length === 0"
              (click)="onRemoveMemberScenario()"
              id="delete-scenario">
        <mat-icon>keyboard_double_arrow_left</mat-icon>
      </button>
    </div>
    <div class="w-50">
      <div class="table-title">
        <span>Selected Member Scenarios</span>
      </div>
      <ag-grid-angular
        style="height: 100%; width:100%;"
        class="ag-theme-quartz"
        [rowData]="memberScenarios"
        [columnDefs]="INDUSTRY_COLDEF"
        [autoSizeStrategy]="autoSizeStrategy"
        [rowSelection]="rowSelection"
        (rowSelected)="onMemberSelect($event)"
      />
    </div>
  </div>
</div>
